// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2ix3Q","select":"Header_select__WWRy6","clinic":"Header_clinic__1jatJ"};